import {WelcomeModalController} from './welcome-modal.ctrl'

const welcomeModalPopup = () => {
  return {
    restrict: 'AE', // E for element/tag, A for attribute
    template: require('./welcome-modal.html'),
    controller: WelcomeModalController,
  }
}

angular
  .module('app.directives')
  .directive('welcomeModalPopup', welcomeModalPopup)



// WEBPACK FOOTER //
// ./scripts/matches/welcome-modal-popup/welcome-modal.directive.js